import PropTypes from "prop-types"

// import FeaturedSlider from "./slider/featured-slider"
import NativeSlickSlider from "./slider/native-slick-slider"

const LandingSlider = ({ element, lazyload }) => {
  // Only render first 5 items on initial DOM load, then load the rest after
  const slides = element.items.filter(
    (item) =>
      !item.countries ||
      item.countries?.includes(sl.config.site_country.toUpperCase()) ||
      item.countries?.length < 1
  )

  if (["native", "slick"].includes(element.slider_type)) {
    return (
      <NativeSlickSlider
        element={element}
        lazyload={lazyload}
        slides={slides}
      />
    )
    // } else if (element.slider_type === "featured") {
    //   return (
    //     <FeaturedSlider element={element} lazyload={lazyload} slides={slides} />
    //   )
  }
}

LandingSlider.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default LandingSlider
